import { Symbol } from "../../../../interface/Symbol"

export const useFilter = (query: string, symbols: Symbol[]) => {

  if(!query) return symbols
  return symbols.filter(s => s.symbol.toLowerCase().includes(query.toLowerCase()))
}
